import { ISuccess } from '~/src/dash/api/console-api';
import { IPermissionsTemplate, IRole } from '~/src/dash/api/permissions/model';
import { createUrl, restDelete, restGet, restPost, restPut } from '~/src/dash/api/rest';

export async function createRole(
  name: string,
  publisherID: number,
): Promise<[IRole | undefined, Error | undefined]> {
  const reqUrl = createUrl('/role', publisherID.toString());

  try {
    return [
      (
        await restPost<IRole>(reqUrl, {
          publisherID,
          name,
        } as Partial<IRole>)
      ).parsedBody,
      undefined,
    ];
  } catch (e) {
    console.error(e);
    return [undefined, e];
  }
}

export async function updateRole(
  role: IRole,
  publisherID: number,
): Promise<[IRole | undefined, string | undefined]> {
  const reqUrl = createUrl('/role', publisherID.toString());

  try {
    return [(await restPut<IRole>(reqUrl, role)).parsedBody, undefined];
  } catch (e) {
    console.error(e);
    return [undefined, e];
  }
}

export async function getPermissionTemplate(
  publisherID: number,
): Promise<[IPermissionsTemplate | undefined, string | undefined]> {
  const reqUrl = createUrl('/permissions', publisherID.toString());

  try {
    return [(await restGet<IPermissionsTemplate>(reqUrl)).parsedBody, undefined];
  } catch (e) {
    console.error(e);
    return [undefined, e];
  }
}

export async function updateRoleForUser(
  roleID: number,
  userID: number,
  publisherID: number,
): Promise<[IRole | undefined, string | undefined]> {
  const reqUrl = createUrl('/role/user', publisherID.toString());

  try {
    return [
      (
        await restPut<IRole>(reqUrl, {
          roleID,
          userID,
        })
      ).parsedBody,
      undefined,
    ];
  } catch (e) {
    return [undefined, e];
  }
}

export async function deleteUser(
  userID: number,
  publisherID: number,
): Promise<[boolean | undefined, string | undefined]> {
  // Create the URL.
  const reqUrl = createUrl('/user', publisherID.toString());

  // Call the URL using the DELETE method, and handle any error.
  try {
    const successObject = (await restDelete<ISuccess>(reqUrl, { userID })).parsedBody;
    if (!successObject) {
      return [undefined, 'API response is not in the expected format'];
    } else {
      return [successObject.status, undefined];
    }
  } catch (e) {
    return [undefined, e];
  }
}
